<template>
  <Base>
    <template v-slot:toolbar>
      <!-- Masque sur mobile : l'en-tete .wm-head le remplace (titre, compteur,
           recherche, action principale). Deux barres l'une sur l'autre. -->
      <div v-if="!isMobile" id="kt_toolbar" class="toolbar">
        <div
          id="kt_toolbar_container"
          class="container-fluid d-flex flex-stack"
        >
          <div class="d-flex align-items-center me-3">
            <slot name="leftToolbar">
              <span class="h-20px border-gray-200 border-start mx-4"></span>
              <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
                <li class="breadcrumb-item text-muted">
                  <router-link
                    :to="{ name: 'dashboard' }"
                    class="text-muted text-hover-primary"
                  >
                    <i class="fad fa-home"></i>
                    Tableau de bord
                  </router-link>
                </li>
              </ul>
            </slot>
          </div>

          <div class="d-flex align-items-center py-1">
            <date-range-picker
              ref="picker"
              v-model="range"
              :autoApply="false"
              :locale-data="localData"
              :opens="'left'"
              :ranges="ranges"
              :showDropdowns="true"
              :showWeekNumbers="true"
              :singleDatePicker="false"
              :timePicker="false"
              @update="load"
            >
              <template v-slot:input="picker" style="min-width: 350px">
                <template>
                  {{ readableDate(picker.startDate, "dmY") }} ❖
                  {{ readableDate(picker.endDate, "dmY") }}
                </template>
              </template>
            </date-range-picker>

            <div class="d-flex align-items-center">
              <div>
                <button
                  v-if="search.start && search.end"
                  class="btn btn-icon btn-sm btn-info ms-1"
                  @click="requestPrintable"
                >
                  <i class="fad fa-print"></i>
                </button>
              </div>
              <div>
                <button
                  v-b-modal="'paymentGenerator'"
                  class="btn btn-sm btn-primary ms-1"
                >
                  <i class="fad fa-plus"></i>
                  Générer un lien de paiement
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #content>
      <div
        v-if="generatedLink"
        class="bg-light-primary p-5 rounded border-dashed border-primary mb-5 text-primary fs-2 fw-bolder"
      >
        Votre lien de paiement généré :
        <a :href="generatedLink"> {{ generatedLink }} </a>
      </div>
      <!-- <div class="d-flex justify-content-end">
          <div class="btn btn-primary my-5" v-if="selectedUuids.length > 0" @click="printReceipts">
            <i class="fad fa-print"></i>
            Imprimer les reçus ({{ selectedUuids.length }})
          </div>
        </div> -->
      <!-- Sur mobile, l'ecran .wm-screen se pose seul : ni carte Metronic, ni
           entete de carte (elle porte les filtres et boutons du bureau, que
           l'en-tete mobile et le tiroir remplacent). -->
      <div :class="isMobile ? '' : 'card'">
        <div v-if="!isMobile" class="card-header justify-content-end">
          <div class="d-flex align-items-center">
            <button
              class="btn btn-sm btn-icon btn-danger me-2"
              @click="resetSearch()"
            >
              <i class="fad fa-trash"></i>
            </button>

            <b-dropdown
              id="dropdown-1"
              ref="cotationFilter"
              no-caret
              no-flip
              right
              size="sm"
              style="padding: 0"
              tag="div"
              toggle-class="topbar-item text-decoration-none"
              variant="link"
            >
              <template v-slot:button-content>
                <b-button id="popover-search" size="sm" variant="secondary"
                  >Rechercher
                </b-button>
              </template>

              <b-dropdown-text class="min-w-750px" tag="div">
                <div class="row w-100 align-items-center">
                  <div class="col-4">
                    <label class="my-4 fw-bolder" for="">{{
                      trans("Gestionnaire")
                    }}</label>
                    <b-form-select
                      v-model="search.manager"
                      class="form-control form-select"
                      @keyup.enter="load()"
                    >
                      <b-form-select-option :value="null"
                        >{{ trans("Selectionner un gestionnaire") }}
                      </b-form-select-option>
                      <b-form-select-option value="all"
                        >{{ trans("Tous") }}
                      </b-form-select-option>

                      <b-form-select-option
                        v-for="manager in managers"
                        :key="manager.uuid"
                        :value="manager.email"
                      >
                        {{ manager.name + " " + manager.prename }}
                      </b-form-select-option>
                    </b-form-select>
                  </div>
                  <div class="col-8">
                    <label class="my-4 fw-bolder" for="">
                      {{
                        trans(
                          "Information (numero de police , Nom du client , etc...)"
                        )
                      }}
                    </label>
                    <input
                      v-model="search.contains"
                      class="form-control"
                      type="text"
                    />
                  </div>

                  <div class="col-12">
                    <label class="my-4 fw-bolder" for="">
                      {{ trans("Tranche de prix") }}
                    </label>
                    <div class="input-group mb-3">
                      <input
                        v-model="search.minPrice"
                        class="form-control"
                        placeholder="Montant minimum"
                        type="number"
                      />
                      <span class="input-group-text">
                        <i class="fad fa-right-left"></i>
                      </span>
                      <input
                        v-model="search.maxPrice"
                        class="form-control"
                        placeholder="Montant maximum"
                        type="number"
                      />
                    </div>
                  </div>

                  <div class="col-12 my-8 d-flex flex-column">
                    <div>
                      <label class="mx-4 fw-bolder" for="">
                        {{ trans("Methode de paiement") }}
                      </label>
                    </div>
                    <br />
                    <div>
                      <div
                        v-for="(method, index) in methods"
                        :key="index"
                        class="form-check form-check-inline"
                      >
                        <input
                          :id="method.slug"
                          v-model="search.methods"
                          :value="method.slug"
                          class="form-check-input"
                          type="checkbox"
                        />
                        <label :for="method.slug" class="form-check-label">{{
                          method.label
                        }}</label>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 my-8 d-flex flex-column">
                    <div>
                      <label class="mx-4 fw-bolder" for="">
                        {{ trans("Status") }}
                      </label>
                    </div>
                    <br />
                    <div>
                      <div
                        v-for="(status, index) in CONSTANTS.PAYMENT_STATUS"
                        :key="index"
                        class="form-check form-check-inline"
                      >
                        <input
                          :id="status"
                          v-model="search.status"
                          :value="index"
                          class="form-check-input"
                          type="checkbox"
                        />
                        <label :for="status" class="form-check-label">{{
                          status
                        }}</label>
                      </div>
                    </div>
                  </div>

                  <div
                    class="d-flex justify-content-end align-items-center my-5"
                  >
                    <button
                      class="btn btn-sm btn-primary"
                      type="submit"
                      @click="load()"
                    >
                      Commencer la recherche
                    </button>
                  </div>
                </div>
              </b-dropdown-text>
            </b-dropdown>
          </div>
        </div>
        <!-- ECRAN MOBILE (charte .wm-*) -->
        <div v-if="isMobile" class="wm-screen">
          <div class="wm-head">
            <div class="wm-head-top">
              <div>
                <div class="wm-head-title">Paiements</div>
                <div class="wm-head-sub">
                  {{ readable(search.start, 'dMY') }} &mdash; {{ readable(search.end, 'dMY') }}
                </div>
              </div>
              <div class="wm-head-actions">
                <button class="wm-cta" v-b-modal.paymentGenerator>+ Lien</button>
              </div>
            </div>
            <label class="wm-search">
              <i class="fad fa-magnifying-glass"></i>
              <input v-model="search.contains" type="search"
                     placeholder="N&deg; de police, nom du client..."
                     @keyup.enter="mobileSearch()"/>
            </label>
            <div class="wm-chips">
              <button class="wm-chip wm-chip--filters" @click="filtersOpen = true">
                Filtres
                <span v-if="activeFilterCount > 0" class="wm-chip-count">{{ activeFilterCount }}</span>
              </button>
              <button v-for="st in search.status" :key="'st_' + st"
                      class="wm-chip wm-chip--active" @click="toggleMobileStatus(st)">
                {{ st }} <i class="fad fa-xmark"></i>
              </button>
              <button class="wm-chip" @click="filtersOpen = true">
                M&eacute;thode <i class="fad fa-chevron-down"></i>
              </button>
              <button class="wm-chip" @click="filtersOpen = true">
                Tranche de prix <i class="fad fa-chevron-down"></i>
              </button>
              <button class="wm-chip" @click="filtersOpen = true">
                Gestionnaire <i class="fad fa-chevron-down"></i>
              </button>
            </div>
          </div>

          <div class="wm-meta">
            <span class="wm-meta-count">{{ payments.length }} paiement{{ payments.length > 1 ? 's' : '' }}</span>
          </div>

          <div class="wm-list">
            <div v-if="payments.length === 0" class="wm-empty" style="margin:14px">
              Aucun paiement sur cette p&eacute;riode
            </div>
            <div v-for="payment in payments" :key="'mp_' + payment.id" class="wm-row">
              <div class="wm-row-top">
                <span class="wm-row-title">{{ payment.customerFullname || '-' }}</span>
                <span class="wm-amount">{{ currency(payment.amount) }}</span>
              </div>
              <div class="wm-row-top" style="margin-top:4px">
                <span class="wm-mono wm-row-sub" style="margin-top:0">
                  {{ payment.contact ? phoneFormat(payment.contact) : '' }}
                </span>
                <span class="wm-badge" :class="paymentBadgeClass(payment)">{{ payment.status }}</span>
              </div>
              <div class="wm-row-sub" style="margin-top:7px;line-height:1.45">
                Avenant N&deg;{{ payment.avenantNumber }}
                <template v-if="payment.contractNumber">
                  &middot; <span class="wm-mono" style="color:var(--wm-primary-ink)">{{ payment.contractNumber }}</span>
                </template>
              </div>
              <div class="wm-row-line">
                <span v-if="payment.method" class="wm-tag">{{ payment.method.label }}</span>
                <span class="wm-row-sub" style="margin-top:0;flex:1">
                  {{ readable(payment.payedAt || payment.createdAt, 'dMY Hi') }}
                </span>
              </div>

              <!-- Les actions de la ligne du bureau : recu, verification du statut
                   quand il est en attente, traitement pour un admin. -->
              <div class="wm-row-actions">
                <router-link :to="{name: 'receipt-show', params: {uuid: payment.uuid}}"
                             class="wm-act wm-act--primary" target="_blank"
                             :title="trans('Recu')">
                  <i class="fad fa-download"></i>
                </router-link>
                <button v-if="payment.status === 'PENDING'" class="wm-act"
                        :title="trans('Verifier le statut')" @click="checkStatus(payment)">
                  <i class="fad fa-sync"></i>
                </button>
                <button v-if="hasRole('ROLE_ADMIN') && !payment.processed && !payment.processing && payment.status === 'SUCCEED'"
                        class="wm-act wm-act--danger"
                        :title="trans('Traiter le paiement')" @click="processPayment(payment)">
                  <i class="fad fa-gears"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div v-show="!isMobile" class="card-body">
          <table class="table table-striped gy-3 gs-2">
            <thead>
              <tr
                class="fw-bold fs-6 text-gray-800 border-bottom border-gray-200"
              >
                <!-- <th>
                <div class="form-check form-check-custom  form-check-sm" @change="toggleAll">
                  <input class="form-check-input" type="checkbox">
                </div>
              </th> -->
                <th>{{ trans("N°") }}</th>
                <th>{{ trans("ID") }}</th>
                <th>{{ trans("Date") }}</th>
                <th>{{ trans("Methode") }}</th>
                <th>{{ trans("Label") }}</th>
                <th>{{ trans("Client") }}</th>
                <th>{{ trans("Initiateur") }}</th>
                <th>{{ trans("Source") }}</th>
                <th>{{ trans("Montant") }}</th>
                <th>{{ trans("Status") }}</th>
                <th>{{ trans("Actions") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(payment, index) in payments">
                <td>
                  <div class="d-flex align-items-center">
                    <RowSelector v-model="selectedUuids" :data="payment.uuid" />
                    <div class="ms-2 fw-bolder">
                      {{ index + 1 }}
                    </div>
                  </div>
                </td>
                <td>
                  {{ payment.id }}
                </td>
                <td>
                  <template v-if="payment.payedAt">
                    {{ readable(payment.payedAt, "dMY Hi") }}
                  </template>
                  <template v-else-if="payment.createdAt">
                    {{ readable(payment.createdAt, "dMY Hi") }}
                  </template>
                </td>
                <td>
                  <template v-if="payment.method">
                    {{ payment.method.label }}
                  </template>
                </td>
                <td>
                  <div v-if="payment.contractUuid" class="text-center">
                    Paiement de l'avenant N°{{ payment.avenantNumber }} du
                    contrat
                    <router-link
                      :to="{
                        name: 'contract-show',
                        params: { contractUuid: payment.contractUuid },
                      }"
                      class="fw-bolder"
                    >
                      {{ payment.contractNumber }}
                    </router-link>
                  </div>
                  <div v-else class="d-flex justify-content-center">
                    <div>
                      {{ payment.label }}
                    </div>
                    <div
                      class="btn btn-primary btn-sm"
                      @click="linkPayment(payment)"
                    >
                      <i class="fad fa-link"></i>
                      Lier à un Contrat
                    </div>

                    <b-modal
                      :id="'modalLink_' + payment.id"
                      size="lg"
                      title="Lier le paiement à une facture"
                    >
                      <div>
                        <h1>Trouver le contrat</h1>

                        <div class="p-1 d-flex flex-column align-items-center">
                          <input
                            v-model="fieldSearch"
                            class="form-control my-3"
                            placeholder="Renseignez le numero de police du contrat ou le numero du contrat"
                            type="text"
                          />
                          <button
                            class="btn btn-primary"
                            @click="searchContract"
                          >
                            <i class="fad fa-search"></i> Rechercher
                          </button>
                        </div>

                        <div class="my-5">
                          <!-- Liste des contrats trouvés -->
                          <template v-for="(contract, index) in contracts">
                            <div :key="index">
                              <div
                                class="bg-secondary p-5 mb-3 d-flex justify-content-between rounded cursor-pointer"
                                @click="loadContractInvoices(contract)"
                              >
                                <span class="text-primary fw-bolder"
                                  >Contrat N° {{ contract.number }}</span
                                >
                                <span v-if="contract.subscriber">{{
                                  contract.subscriber.identifier
                                }}</span>
                              </div>
                            </div>
                          </template>

                          <!-- Factures du contrat sélectionné -->
                          <div
                            v-if="selectedContract && invoices.length > 0"
                            class="mt-5"
                          >
                            <h4 class="mb-3">
                              <i class="fad fa-file-invoice me-2"></i>
                              Factures du contrat N°
                              {{ selectedContract.number }}
                            </h4>
                            <table class="table table-striped gy-3 gs-3">
                              <thead>
                                <tr
                                  class="fw-bolder fs-6 text-gray-800 border-bottom border-gray-200"
                                >
                                  <th>Numéro</th>
                                  <th>Créée le</th>
                                  <th>Échéance</th>
                                  <th>Montant</th>
                                  <th>Reste à payer</th>
                                  <th>Statut</th>
                                  <th>Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="invoice in invoices"
                                  :key="'invoice_' + invoice.id"
                                >
                                  <td>
                                    <span class="text-primary fw-bolder">{{
                                      invoice.number
                                    }}</span>
                                  </td>
                                  <td>
                                    {{ readable(invoice.createdAt, "dmy") }}
                                  </td>
                                  <td>
                                    {{ readable(invoice.dueDate, "dmy") }}
                                  </td>
                                  <td class="fw-bolder">
                                    {{ currency(invoice.premium) }}
                                  </td>
                                  <td
                                    class="fw-bolder"
                                    :class="{
                                      'text-danger':
                                        Math.abs(invoice.balance) > 0,
                                    }"
                                  >
                                    {{ currency(invoice.balance, true) }}
                                  </td>
                                  <td>
                                    <span
                                      class="badge"
                                      :class="{
                                        'badge-secondary':
                                          invoice.status === 'PENDING',
                                        'badge-success':
                                          invoice.status === 'PAYED',
                                        'badge-danger':
                                          invoice.status === 'CANCELLED',
                                      }"
                                    >
                                      {{ invoice.status }}
                                    </span>
                                  </td>
                                  <td class="text-end">
                                    <button
                                      class="btn btn-icon btn-primary btn-sm"
                                      :disabled="
                                        invoice.status === 'PAYED' ||
                                        invoice.status === 'CANCELLED'
                                      "
                                      @click="
                                        linkPaymentToInvoice(invoice, payment)
                                      "
                                    >
                                      <i class="fad fa-link"></i>
                                    </button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>

                          <!-- Message si aucune facture -->
                          <div
                            v-if="selectedContract && invoices.length === 0"
                            class="text-center p-5"
                          >
                            <i class="fad fa-empty-set fs-3x text-muted"></i>
                            <div class="mt-3 fw-bolder">
                              Aucune facture pour ce contrat
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-modal>
                  </div>
                </td>
                <td>
                  <router-link
                    v-if="payment.customerUuid"
                    :to="{
                      name: 'customer-show',
                      params: { uuid: payment.customerUuid },
                    }"
                    class="fw-bolder"
                  >
                    {{ payment.customerFullname }}
                  </router-link>
                  <div v-if="payment.contact" class="fw-bolder">
                    {{ phoneFormat(payment.contact) }}
                  </div>
                </td>
                <td>
                  <user-view v-model="payment.initiator" />
                </td>
                <td>
                  <partner-view
                    v-if="payment.partner"
                    v-model="payment.partner"
                  ></partner-view>
                </td>
                <td class="fw-bolder fs-2 text-end">
                  {{ currency(payment.amount) }}
                </td>
                <td>
                  <span
                    :class="{
                      'badge-success': payment.status === 'SUCCEED',
                      'badge-secondary': payment.status === 'PENDING',
                      'badge-danger': payment.status === 'CANCELLED',
                    }"
                    class="badge"
                  >
                    {{ payment.status }}
                  </span>
                </td>
                <td>
                  <div class="d-flex gap-4">
                    <router-link
                      :to="{
                        name: 'receipt-show',
                        params: { uuid: payment.uuid },
                      }"
                      class="btn btn-sm btn-icon btn-info"
                      target="_blank"
                    >
                      <i class="fad fa-download"></i>
                    </router-link>
                    <div v-if="payment.status === 'PENDING'">
                      <div
                        class="btn btn-secondary btn-icon btn-sm"
                        @click="checkStatus(payment)"
                      >
                        <i class="fad fa-sync"></i>
                      </div>
                    </div>
                    <div
                      class="btn btn-danger btn-icon m-1 btn-sm"
                      v-if="
                        hasRole('ROLE_ADMIN') &&
                        !payment.processed &&
                        !payment.processing &&
                        payment.status === 'SUCCEED'
                      "
                      @click="processPayment(payment)"
                    >
                      <i class="fad fa-gears"></i>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="payments.length === 0 && count > 0">
                <td colspan="11">
                  <div
                    class="d-flex flex-column justify-content-center align-items-center p-10"
                  >
                    <div class="fw-bolder fs-2x mb-5">
                      {{ count }} paiements recensés
                    </div>
                    <div>
                      <div
                        v-if="count > 0"
                        class="btn btn-primary"
                        @click="load"
                      >
                        Charger
                      </div>
                      <div
                        v-if="count > 0"
                        class="btn btn-info ms-2"
                        @click="requestPrintable"
                      >
                        Imprimer
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="loading">
                <td colspan="11">
                  <Loading />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- TIROIR DE FILTRES (mobile). Les filtres du bureau vivent dans un
             b-dropdown de la barre d'outils, inutilisable tel quel sur telephone :
             on offre ici une surface propre au mobile, branchee sur le MEME objet
             `search`. L'etat reste unique, seule la presentation change. -->
        <transition name="wm-sheet">
          <div v-if="isMobile && filtersOpen">
            <div class="wm-sheet-overlay" @click="filtersOpen = false"></div>
            <div class="wm-sheet">
              <div class="wm-sheet-grip"></div>
              <div class="wm-sheet-head">
                <div class="wm-sheet-title">Filtres</div>
                <button class="wm-sheet-reset" @click="resetSearch(); filtersOpen = false">
                  R&eacute;initialiser
                </button>
              </div>
              <div class="wm-sheet-body">
                <div>
                  <div class="wm-label">Status</div>
                  <div class="wm-choices">
                    <button v-for="st in mobileStatuses" :key="'ms_' + st"
                            class="wm-choice" :class="{'wm-choice--on': search.status.indexOf(st) !== -1}"
                            @click="toggleMobileStatus(st)">
                      {{ st }}
                    </button>
                  </div>
                </div>

                <div>
                  <div class="wm-label">M&eacute;thode</div>
                  <div class="wm-choices">
                    <button v-for="m in methods" :key="'mm_' + m.slug"
                            class="wm-choice" :class="{'wm-choice--on': search.methods.indexOf(m.slug) !== -1}"
                            @click="toggleMobileMethod(m.slug)">
                      {{ m.label }}
                    </button>
                  </div>
                </div>

                <div>
                  <div class="wm-label">Tranche de prix</div>
                  <div style="display:flex;gap:9px">
                    <input v-model="search.minPrice" class="wm-field" type="number" placeholder="Min"/>
                    <input v-model="search.maxPrice" class="wm-field" type="number" placeholder="Max"/>
                  </div>
                </div>

                <div>
                  <div class="wm-label">Gestionnaire</div>
                  <select v-model="search.manager" class="wm-field">
                    <option :value="null">Tous les gestionnaires</option>
                    <option value="all">Tous</option>
                    <option v-for="manager in managers" :key="'mg_' + manager.uuid" :value="manager.email">
                      {{ manager.name + ' ' + manager.prename }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="wm-sheet-actions">
                <button class="wm-btn wm-btn--ghost" @click="filtersOpen = false">Annuler</button>
                <button class="wm-btn wm-btn--primary" @click="mobileSearch()">Rechercher</button>
              </div>
            </div>
          </div>
        </transition>

        <b-modal
          id="paymentGenerator"
          ref="userModal"
          :title="trans('Générer un lien de paiement')"
          centered
          size="lg"
        >
          <form>
            <div>
              <div>
                <div>Opérateur</div>
                <div>
                  <select
                    v-model="generated.method"
                    class="form-control form-select form-control-solid form-control-lg"
                  >
                    <template v-for="method in methods">
                      <option
                        v-if="!method.requireManagerValidation"
                        :value="method.slug"
                      >
                        {{ method.label }}
                      </option>
                    </template>
                  </select>
                </div>
              </div>
              <div>
                <div>Montant</div>
                <div>
                  <input
                    v-model="generated.montant"
                    class="form-control-lg form-control form-control-solid"
                    type="number"
                  />
                </div>
              </div>
              <div>
                <div>Numéro de téléphone</div>
                <div>
                  <input
                    v-model="generated.phone"
                    class="form-control-lg form-control form-control-solid"
                    type="text"
                  />
                </div>
              </div>
            </div>
          </form>
          <template #modal-footer="{ ok, cancel, hide }">
            <b-button size="sm" variant="secondary" @click="cancel()">
              <i class="fad fa-times"></i>
              {{ trans("Cancel") }}
            </b-button>
            <b-button
              size="sm"
              variant="primary"
              @click="
                generatePayment();
                hide();
              "
            >
              <i class="fad fa-save"></i>
              {{ trans("Save") }}
            </b-button>
          </template>
        </b-modal>
      </div>
    </template>
  </Base>
</template>
<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import Base from "@/layouts/Base.vue";
import MobileAware from "@/mixins/MobileAware";
import User from "@/entity/User";
import FileUpload from "@/components/FileUpload.vue";
import RowSelector from "@/components/RowSelector.vue";
import { api } from "@/services/Api";
import PaymentTransaction from "@/entity/PaymentTransaction";
import CONSTANTS from "@/Utils/constant";
import { helper } from "@/services/Helper";
import UserView from "@/components/UserView.vue";
import Loading from "@/components/Loading.vue";
import PartnerView from "@/components/PartnerView.vue";
import DateRangePicker from "vue2-daterange-picker";
import Popup from "@/entity/Popup";
import PaymentMethod from "@/entity/PaymentMethod";
import Swal from "sweetalert2";
import Contract from "@/entity/Contract";
import Avenant from "@/entity/Avenant";
import Invoice from "@/entity/Invoice";

@Component({
  // `mixins` en OPTION : `extends mixins(...)` fait perdre le typage de Vue.
  mixins: [MobileAware],
  components: {
    PartnerView,
    UserView,
    FileUpload,
    Base,
    Loading,
    RowSelector,
    DateRangePicker,
  },
})
export default class PaymentList extends Vue {
  // Fourni par le mixin MobileAware (declaration de type seulement).
  isMobile!: boolean;
  filtersOpen = false;
  mobileStatuses = ["SUCCEED", "PENDING", "CANCELLED", "FAILED"];

  paymentBadgeClass(payment: any): string {
    if (payment.status === "SUCCEED") return "wm-badge--success";
    if (payment.status === "CANCELLED" || payment.status === "FAILED") return "wm-badge--danger";
    if (payment.status === "PENDING") return "wm-badge--muted";
    return "";
  }

  /** Les filtres reellement poses, pour le compteur de la puce. */
  get activeFilterCount(): number {
    let n = 0;
    if (this.search.status && this.search.status.length > 0) n += this.search.status.length;
    if (this.search.methods && this.search.methods.length > 0) n += this.search.methods.length;
    if (this.search.manager) n++;
    if (this.search.minPrice || this.search.maxPrice) n++;
    if (this.search.contains) n++;
    return n;
  }

  toggleMobileStatus(status: string) {
    const i = this.search.status.indexOf(status);
    if (i === -1) {
      this.search.status.push(status);
    } else {
      this.search.status.splice(i, 1);
    }
  }

  toggleMobileMethod(slug: string) {
    const i = this.search.methods.indexOf(slug);
    if (i === -1) {
      this.search.methods.push(slug);
    } else {
      this.search.methods.splice(i, 1);
    }
  }

  /** Rechercher referme le tiroir : le resultat est derriere. */
  mobileSearch() {
    this.filtersOpen = false;
    this.load();
  }

  searchModel = {
    start: CONSTANTS.dateConstants.first_day_current_month(),
    end: CONSTANTS.dateConstants.last_day_current_month(),
    methods: [],
    status: ["SUCCEED"],
    manager: null,
    contains: null,
    minPrice: null,
    maxPrice: null,
  };
  search: any = {
    start: CONSTANTS.dateConstants.first_day_current_month(),
    end: CONSTANTS.dateConstants.last_day_current_month(),
    methods: [],
    status: ["SUCCEED"],
    manager: null,
    contains: null,
    minPrice: null,
    maxPrice: null,
  };

  resetSearch() {
    this.search = this.searchModel;

    this.load();
  }
  range = {
    startDate: CONSTANTS.dateConstants.first_day_current_month(),
    endDate: CONSTANTS.dateConstants.last_day_current_month(),
  };
  localData = {
    direction: "ltr",
    format: "mm/dd/yyyy",
    separator: " - ",
    applyLabel: "Valider",
    cancelLabel: "Annuler",
    weekLabel: " ",
    customRangeLabel: "Custom Range",
    daysOfWeek: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
    monthNames: [
      "Janvier",
      "Février",
      "Mars",
      "Avril",
      "Mai",
      "Juin",
      "Juillet",
      "Aout",
      "Septembre",
      "Octobre",
      "Novembre",
      "Décembre",
    ],
    firstDay: 0,
  };
  ranges: any = false;
  selectedUuids: string[] = [];
  payments: PaymentTransaction[] = [];
  loading = false;
  methods: PaymentMethod[] = [];
  generated = {
    method: null,
    montant: null as any,
    phone: "",
  };
  managers: User[] = [];
  generatedLink = null;
  printRequest: string = "";
  lastId: number = 0;
  count: number = 0;
  searching: boolean = false;
  searched: any = {};
  fieldSearch: string = "";
  contracts: Contract[] = [];
  invoices: Invoice[] = [];
  selectedContract: Contract | null = null;
  total: number = 0;
  matchCount: number = 0;

  async processPayment(payment: PaymentTransaction) {
    // const res = await api.get(api.core,'payment/')
  }

  async generatePayment() {
    if (
      this.generated &&
      this.generated.method &&
      this.generated.montant > 0 &&
      !helper.empty(this.generated.phone)
    ) {
      this.$store.commit("loading");
      const res = await api.get(
        api.core,
        "api/generate/payment/link/" +
          this.generated.method +
          "/" +
          this.generated.montant +
          "/" +
          this.generated.phone
      );
      this.$store.commit("stopLoading");
      if (res && res.data && res.data.url) {
        const response = await Swal.fire({
          title: "Lien de paiement",
          html:
            'Votre lien de paiement est le suivant : <br><div class="fw-bolder btn btn-primary text-white my-5"><a target="_blank" class="text-white" href="' +
            res.data.url +
            '">Payer ' +
            this.generated.montant +
            " sur " +
            this.generated.method +
            " </a></div>" +
            '<div class="fw-bolder my-5 fs-2">' +
            res.data.url +
            "</div>",
          timerProgressBar: true,
          showCancelButton: true,
          confirmButtonText: "Ok",
          didOpen: () => {
            // Swal.showLoading()
            // const b = Swal.getHtmlContainer().querySelector('b')
            // timerInterval = setInterval(() => {
            //     b.textContent = Swal.getTimerLeft()
            // }, 100)
          },
          willClose: () => {
            // clearInterval(timerInterval)
          },
        });
        // if (response.isConfirmed) {
        //
        // }
        // this.generatedLink = res.data.url
      }
    } else {
      const response = await Swal.fire({
        icon: "error",
        title: "Erreur",
        html: "Veuillez renseigner toutes les informations",
        timer: 10000,
        timerProgressBar: true,
        showCancelButton: true,
        confirmButtonText: "Ok",
        didOpen: () => {
          // Swal.showLoading()
          // const b = Swal.getHtmlContainer().querySelector('b')
          // timerInterval = setInterval(() => {
          //     b.textContent = Swal.getTimerLeft()
          // }, 100)
        },
        willClose: () => {
          // clearInterval(timerInterval)
        },
      });
    }
  }

  async linkPaymentToAvenant(
    avenant: Avenant,
    paymentTransaction: PaymentTransaction
  ) {
    this.$store.commit("loading");
    const res = await api.get(
      api.core,
      "payment/link/" + paymentTransaction.id + "/" + avenant.id
    );
    this.$store.commit("stopLoading");
    if (res && res.data) {
      this.$bvModal.hide("modalLink_" + paymentTransaction.id);
      new Popup(
        "Succès",
        "Paiement lié à l'avenant",
        "success",
        "fad fa-check"
      );
      this.load();
    }
  }

  async linkPaymentToInvoice(
    invoice: Invoice,
    paymentTransaction: PaymentTransaction
  ) {
    this.$store.commit("loading");
    const res = await api.get(
      api.core,
      "payment/link/invoice/" + paymentTransaction.id + "/" + invoice.id
    );
    this.$store.commit("stopLoading");
    if (res && res.data) {
      this.$bvModal.hide("modalLink_" + paymentTransaction.id);
      new Popup(
        "Succès",
        "Paiement lié à la facture",
        "success",
        "fad fa-check"
      );
      this.load();
    }
  }

  async loadContractInvoices(contract: Contract) {
    this.selectedContract = contract;
    this.$store.commit("loading");
    const res = await api.get(
      api.core,
      "contract/invoice/list/" + contract.uuid
    );
    this.$store.commit("stopLoading");
    if (res && res.data && res.data.invoices) {
      this.invoices = [];
      res.data.invoices.forEach((i: any) => {
        this.invoices.push(new Invoice(i));
      });
    }
  }

  loadRanges() {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);
    yesterday.setHours(0, 0, 0, 0);

    this.ranges = {
      Aujourdhui: [today, today],
      Hier: [yesterday, yesterday],
      "Ce mois": [
        CONSTANTS.dateConstants.first_day_current_month(),
        CONSTANTS.dateConstants.last_day_current_month(),
      ],
      "Le mois dernier": [
        new Date(today.getFullYear(), today.getMonth() - 1, 1),
        new Date(today.getFullYear(), today.getMonth(), 0),
      ],
      "Dernier Trimestre": [
        CONSTANTS.dateConstants.first_day(helper.substractMonth(today, 2)),
        CONSTANTS.dateConstants.last_day_current_month(),
      ],
      "Dernier Semestre": [
        CONSTANTS.dateConstants.first_day(helper.substractMonth(today, 5)),
        CONSTANTS.dateConstants.last_day_current_month(),
      ],
      "Cette année": [
        new Date(today.getFullYear(), 0, 1),
        new Date(today.getFullYear(), 11, 31),
      ],
      "L'année passée": [
        new Date(today.getFullYear() - 1, 0, 1),
        new Date(today.getFullYear() - 1, 11, 31),
      ],
      "2 Dernières années": [
        new Date(today.getFullYear() - 1, 0, 1),
        new Date(today.getFullYear(), 11, 31),
      ],
    };
    this.$forceUpdate();
  }

  async requestPrintable() {
    this.printRequest = helper.generateId();
    this.lastId = 0;
    this.preparePrintable();
  }

  async checkStatus(payment) {
    const res = await api.get(api.core, "payment/check/status/" + payment.uuid);
    if (res?.data?.status) {
      this.resetSearch();
    }
  }

  async preparePrintable() {
    this.$store.commit("loading");
    const res = await api.post(api.core, "payment/receipts", {
      ...this.search,
      range: {
        start: this.range.startDate,
        end: this.range.endDate,
      },
      printRequest: this.printRequest,
      lastId: this.lastId,
    });
    if (res && res.data) {
      if (res.data.finished === true) {
        const res = await api.post(
          api.core,
          "payment/download/printable",
          {
            ...this.search,
            range: {
              start: this.range.startDate,
              end: this.range.endDate,
            },
            printRequest: this.printRequest,
          },
          {
            responseType: "blob",
          }
        );
        if (res) {
          const blob = new Blob([res.data], {
            type: res.headers["content-type"] as any,
          });
          let url = window.URL || window.webkitURL;
          let link = url.createObjectURL(blob);
          let a = document.createElement("a");
          var title =
            helper.readable(this.range.startDate) +
            "_au_" +
            helper.readable(this.range.endDate);
          a.setAttribute("download", "Recu_du_" + helper.slugify(title));
          a.setAttribute("href", link);
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
        this.$store.commit("stopLoading");
      } else {
        this.lastId = res.data.lastId;
        await this.preparePrintable();
      }
    } else {
      this.$store.commit("stopLoading");
    }
  }

  async printReceipts() {
    if (helper.empty(this.printRequest)) {
      this.printRequest = helper.generateId();
    }
    this.$store.commit("loading");
    const res = await api.post(
      api.core,
      "payment/receipts",
      {
        range: {
          start: this.range.startDate,
          end: this.range.endDate,
        },
        printRequest: this.printRequest,
      },
      {
        responseType: "blob",
      }
    );
    const blob = new Blob([res.data], {
      type: res.headers["content-type"] as any,
    });
    let url = window.URL || window.webkitURL;
    let link = url.createObjectURL(blob);
    let a = document.createElement("a");
    var title =
      helper.readable(this.range.startDate) +
      "_au_" +
      helper.readable(this.range.endDate);
    a.setAttribute("download", "Recu_du_" + helper.slugify(title));
    a.setAttribute("href", link);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    this.$store.commit("stopLoading");
  }

  toggleAll() {
    if (this.selectedUuids.length == 0) {
      this.selectedUuids = [];
      this.payments.forEach((p) => {
        this.selectedUuids.push(p.uuid!);
      });
    } else {
      this.selectedUuids = [];
    }
    this.$forceUpdate();
  }

  async loadPaymentMethods() {
    const popup = new Popup(
      "Chargement ...",
      "",
      "warning",
      "fad fa-cogs",
      true
    );
    const res = await api.get(api.core, "payment/method/list");
    popup.hide();
    if (res && res.data) {
      this.methods = [];
      res.data.methods.forEach((method: PaymentMethod) => {
        this.methods.push(new PaymentMethod(method));
      });
    }
  }

  async print() {}

  async mounted() {
    this.search = this.searchModel;
    this.loadRanges();
    this.loadPaymentMethods();
    this.load();
    this.managers = await api.loadManagers();
  }

  async process(payment: PaymentTransaction) {
    this.$store.commit("loading");
    const res = await api.get(api.core, "payment/process/" + payment.uuid);
    this.$store.commit("stopLoading");
  }

  async load() {
    this.payments = [];
    this.loading = true;
    this.lastId = 0;
    this.count = 0;
    await this.partialLoad();
  }

  async partialLoad() {
    const start = helper.dateToHtml(this.range.startDate);
    const end = helper.dateToHtml(this.range.endDate);
    const data = {
      lastId: this.lastId,
      ...this.search,
    };
    const res = await api.post(api.core, "payment/list/" + start + "/" + end, {
      ...data,
    });
    if (res && res.data) {
      if (res.data.count !== undefined) {
        this.count = res.data.count;
      }
      res.data.payments.forEach((p: any) => {
        if (p.id < this.lastId || this.lastId === 0) {
          this.lastId = p.id;
        }
        this.payments.push(new PaymentTransaction(p));
      });
      if (res.data.payments.length == 0) {
        this.loading = false;
      } else {
        await this.partialLoad();
      }
    }
  }

  create() {}

  edit() {}

  save() {}

  linkPayment(payment: PaymentTransaction) {
    // Reset les données du modal
    this.contracts = [];
    this.invoices = [];
    this.selectedContract = null;
    this.fieldSearch = "";
    this.$bvModal.show("modalLink_" + payment.id);
  }

  async searchContract() {
    console.log("object");
    if (this.searching) {
      return;
    }
    this.searching = true;
    const res = await api.post(api.core, "contract/search", {
      searched: {
        ...this.searched,
        police: this.fieldSearch,
        numberContract: this.fieldSearch,
        page: 1,
        perPage: 20,
      },
    });
    if (res && res.data && res.data.contracts) {
      this.contracts = [];
      res.data.contracts.forEach((c: Contract) => {
        const occ = new Contract(c);
        this.contracts.push(occ);
      });
      this.total = res.data.total;
      this.matchCount = res.data.matchCount;
    }
    this.searching = false;
  }
}
</script>
<style scoped></style>
